export default __webpack_public_path__ + "static/hero_contact-876b9c45337dcf43388b2ea343347789.jpg";